import styles from './queue.module.css';

/**
 * The eKYC photo slot ("Check the face matches the person in the room").
 * Staging holds no face images: the eKYC provider is not connected, so the
 * slot shows the initial and the verification date the provider would stamp.
 */
export function EkycPhoto({
  name,
  verifiedAt,
}: {
  name: string;
  verifiedAt: string | null;
}) {
  return (
    <span
      className={styles.photo}
      role="img"
      aria-label={
        verifiedAt ? `eKYC photo, verified ${day(verifiedAt)}` : 'No eKYC photo'
      }
    >
      <span className={styles.photoInitial} aria-hidden="true">
        {name.trim()[0]?.toUpperCase()}
      </span>
      <span className={styles.photoCaption}>
        {verifiedAt ? `eKYC ${day(verifiedAt)}` : 'Not verified'}
      </span>
    </span>
  );
}

const day = (iso: string) =>
  new Date(iso).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
